import { Box, Container, Typography } from "@mui/material";

const rubikfont = {
  fontFamily: "Rubik, san-serif"
};

function EmailSubscribe() {
  return (
    <Box
      sx={{
        width: "100%",
        py: 10,
        background: "linear-gradient(135deg, #222 0%, #333 100%)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("img/subsimage.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.1
        }
      }}
    >
      <Container sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            textAlign: "center",
            maxWidth: "700px",
            mx: "auto"
          }}
        >
          {/* Small Label */}
          <Typography
            sx={{
              fontSize: "12px",
              letterSpacing: "3px",
              color: "rgba(255,255,255,0.7)",
              mb: 2,
              ...rubikfont,
              fontWeight: 500
            }}
          >
            NEWSLETTER
          </Typography>

          {/* Main Heading */}
          <Typography
            sx={{
              fontSize: { xs: "32px", md: "42px" },
              fontWeight: 700,
              color: "white",
              mb: 2,
              ...rubikfont,
              letterSpacing: "1px"
            }}
          >
            STAY UPDATED
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: 1.7,
              color: "rgba(255,255,255,0.8)",
              mb: 5,
              ...rubikfont
            }}
          >
            Subscribe to our newsletter and get exclusive deals, new product
            launches, and grooming tips delivered straight to your inbox.
          </Typography>

          {/* Email Input Form */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              maxWidth: "550px",
              mx: "auto",
              flexDirection: { xs: "column", sm: "row" }
            }}
          >
            <Box
              component="input"
              type="email"
              placeholder="Enter your email address"
              sx={{
                flex: 1,
                px: 3,
                py: 2,
                border: "2px solid rgba(255,255,255,0.2)",
                bgcolor: "rgba(255,255,255,0.05)",
                color: "white",
                fontSize: "15px",
                outline: "none",
                transition: "all 0.3s ease",
                ...rubikfont,
                "&::placeholder": {
                  color: "rgba(255,255,255,0.5)"
                },
                "&:focus": {
                  border: "2px solid white",
                  bgcolor: "rgba(255,255,255,0.1)"
                }
              }}
            />
            <Box
              component="button"
              sx={{
                bgcolor: "white",
                color: "#222",
                px: 5,
                py: 2,
                border: "none",
                cursor: "pointer",
                fontWeight: 600,
                fontSize: "14px",
                letterSpacing: "2px",
                transition: "all 0.3s ease",
                ...rubikfont,
                "&:hover": {
                  bgcolor: "#f0f0f0",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 20px rgba(255,255,255,0.2)"
                },
                "&:active": {
                  transform: "translateY(0)"
                }
              }}
            >
              SUBMIT
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default EmailSubscribe;
